var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 167,
    transform: "translate(-40 -102)",
    fill: "#1F2128"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -102,
    width: 256,
    height: 2296,
    fill: "black",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -18,
    width: 216,
    height: 56,
    rx: 12,
    fill: "#1F2128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4016 18.9142V6.05449H18.1635V7.58022H20.9001V18.9384H17.2674V7.556V0H6.65994V8.3552V18.9142H3.02725V7.58022H5.76388V6.05449H1.52573V18.9142H0V20.44H1.52573H6.68416H8.20989H15.7901H17.3158H22.4743H24V18.9142H22.4016ZM15.7417 7.556V18.9384H8.18567V8.3552V1.52573H15.7659V7.556H15.7417Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2129 3.02722H9.68719V14.3854H11.2129V3.02722Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2401 3.02722H12.7144V14.3854H14.2401V3.02722Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9798 9.68716H19.0837V8.9364H18.1635V10.6074H19.9798V9.68716Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76386 9.68716H4.84357V8.9364H3.94751V10.6074H5.76386V9.68716Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76386 12.7144H4.84357V11.9637H3.94751V13.6347H5.76386V12.7144Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94751 14.9909V16.6619H5.76386V15.7417H4.84357V14.9909H3.94751Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9798 12.7144H19.0837V11.9637H18.1635V13.6347H19.9798V12.7144Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9798 15.7417H19.0837V14.9909H18.1635V16.6619H19.9798V15.7417Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_0_1",
    x: -40,
    y: -102,
    width: 256,
    height: 2296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.894118 0 0 0 0 0.894118 0 0 0 0.100962 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 167,
    fill: "white",
    transform: "translate(-40 -102)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTravel);
export default __webpack_public_path__ + "static/media/ico-travel.115d363c.svg";
export { ForwardRef as ReactComponent };